import React from "react";
import { Button, Col } from "antd";
import { PuffLoader } from 'react-spinners';
import * as XLSX from "xlsx";

function BtnExcel({
  size,
  isClicked,
  label,
  excelData,
  xlsxHeaders,
  fileName,
  handleData,
}) {
  function handleExport() {
    handleData()

    if(!isClicked){
      const rows = excelData;
      /* generate worksheet and workbook */
      const worksheet = XLSX.utils.json_to_sheet(rows);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");
      XLSX.utils.sheet_add_aoa(worksheet, [xlsxHeaders], { origin: "A1" });
      XLSX.writeFile(workbook, fileName, { compression: true });
    }
  }

  return (
    <Col className="p-1">
      {isClicked ? (
        <Button className="excel-color excel-header-btn" size={size}>
           <PuffLoader color="white" size={20} />
        </Button>
      ) : (
        <Button className="excel-color excel-header-btn" size={size} onClick={handleExport}>
          {label}
        </Button>
      )}
    </Col>
  );
}

export default BtnExcel;
